import React, { Fragment, useEffect, useState, useContext, Children } from "react";
import { Link } from "react-router-dom";
import styled, { css } from "styled-components";
import { MenuMain } from "./MenuMain";
import { MenuDay } from "./MenuDay";
import { DayFilters } from "./DayFilters";
import { DayGrid } from "./DayGrid";
import { MenuTabs } from "./MenuTabs";
import { Player } from "./Player";
import { Playlist } from './Playlist';
import { LayoutSwitcher } from "./LayoutSwitcher";
import { getDataById, getDataByUniq } from './utils';
import { Context } from '../context';
import "react-perfect-scrollbar/dist/css/styles.css";
import PerfectScrollbar from "react-perfect-scrollbar";
import { MenuTeams } from './MenuTeams';
import { MenuTeam } from './MenuTeam';
import { PlaylistAddButton } from "./PlaylistAddButton";




export function Layout({ playlistId, videoId, children }) {

  const context = useContext(Context);

  videoId = videoId || getDataById(context, 'playlists', playlistId, 'videos')

  return (
    <>
      <div className="b0">



        <div className="l_bg"></div>
        {/* <MenuTeams /> */}

        <div className="l_c">




          <MenuMain />




          <div className="l_c_inner">



            {/* <div className={`l_catalog ${Boolean(videoId) ? 'l_catalog--v' : ''}`}> */}
            <div className={`l_catalog ${Boolean(videoId) ? 'l_catalog--video' : ''}`}>
              <div className={`l_catalog_inner`}>

                <div className="l_playlist">
                  {children}
                </div>



              </div>


            </div>


            {Boolean(videoId) && <Player />}

          </div>
        </div>

      </div>
    </>
  );
}







export function LayoutOld({ playlistId, videoId, children }) {

  const context = useContext(Context);

  videoId = videoId || getDataById(context, 'playlists', playlistId, 'videos')

  return (
    <>
      <div className="b0">
        <MenuMain />

        <div className="c00">
          <div className="l_main0">

            <div className="x_bg" />

            <div className="l_main">





              {/* <DayGrid/> */}

              {/* <LayoutSwitcher/> */}


              <div className={`l_catalog`}>
                {/* <PerfectScrollbar className="l_catalog"> */}
                <div className={`l_catalog_inner`}>

                  {/* <div className={`l_catalog_inner ${videoId ? 'l_catalog_inner--full' : ''}`}> */}

                  <div className="l_playlist l_playlist--sm">
                    {children}
                  </div>
                </div>

                <PlaylistAddButton />

                {/* </PerfectScrollbar> */}
              {Boolean(videoId) && <Player />}
            </div>
            </div>



          </div>
        </div>
      </div>
    </>
  );
}
